// TODO:
// Это временный хук, работа со ВСЕМИ категориями должна происходить с помощью useInfiniteCategory
import { useInfiniteQuery, UseInfiniteQueryResult } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import * as ApiCategory from '@Api/Category';
import { CatalogData } from '@Types/Catalog';
import { isBrowser } from '@Utils/checkRuntime';
import useSearchParams from '@Hooks/useSearchParams';

export interface Params {
  slug: string;
  ssr?: boolean;
}

export type Result = UseInfiniteQueryResult<CatalogData>;

const useInfinitePromoCategory = (params: Params): Result => {
  const { slug, ssr = true } = params || {};
  const { pathname, search } = useLocation();
  const searchParams = useSearchParams();
  const matches = pathname.match(/.*page-([0-9]{0,})$/);
  const initialPage = Number(matches ? matches[1] : 1);
  const keys = ['infinitePromoCategory', pathname, searchParams.toString(), slug].filter(Boolean);

  const category = useInfiniteQuery(
    keys,
    ({ pageParam }) => {
      return ApiCategory.getPromoProducts({
        slug,
        page: pageParam || initialPage,
        search,
        isInit: !pageParam,
      });
    },
    {
      enabled: ssr || isBrowser,
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (typeof lastPage.sectionCountLeft === 'number') {
          return lastPage.sectionCountLeft ? lastPage.page + 1 : null;
        }

        return lastPage.productsCountLeft ? lastPage.page + 1 : null;
      },
    },
  );

  return category;
};

export default useInfinitePromoCategory;
